<template>
  <div class="discover-tabs">
    <div @click="setMode(key)" :class="{'active' : filterType === key}" v-for="(name, key) in tabs" class="discover-tabs-tab">
      <span>{{trans(name)}}</span>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import discoverModule from '@discover/module/store/type';

export default {
  mixins: [
    require('@general/lib/mixin').default,
    require('@general/lib/mixin-discover').default,
  ],
  props: [],
  data() {
    return {

    }
  },
  components: {
  },
  computed: {
    tabs(){
      return {
        'nearby' : 'all',
        'recent' : 'new',
        'favorites' : 'favorites'
      }
    },
    ...mapState({

    }),
    ...mapGetters({
      meetNowUsers: 'meetNowUsers'
    })
  },
  methods: {
    setMode(mode,e) {
      if(this.showJoinModalIfNeed(e)){
        return false;
      }
      this.$store.dispatch(discoverModule.actions.filter.set, {
        key: 'filterType',
        value: mode,
        refresh: true
      })
    },
    goToProfile(user) {
      this.goTo('/user/' + user.id)
      // this.$router.push({ hash: '#userModal='+user.id })
      //this.openUserMobileModal(user.id, 2)
    },
  },
  mounted() {
  },
  deactivated() {
  },
  destroyed() {
  }
}
</script>